import { VoiceCallContext } from '@troyai/care-management/data-access';
import {
  AircallEverywhereCallEndRingtoneEvent,
  AircallEverywhereCallEndedEvent,
  AircallEverywhereIncomingCallEvent,
  AircallEverywhereOutgoingAnsweredEvent,
  AircallEverywhereOutgoingCallEvent,
} from '../models/aircall-everywhere.interface';

export class AircallIncomingCall {
  static readonly type = '[Aircall] Incoming Call';
  constructor(
    public payload: {
      call: AircallEverywhereIncomingCallEvent;
    }
  ) {}
}

export class AircallCallEndRingtone {
  static readonly type = '[Aircall] Call End Ringtone';
  constructor(
    public payload: {
      call: AircallEverywhereCallEndRingtoneEvent;
    }
  ) {}
}

export class AircallOutgoingCallAnswered {
  static readonly type = '[Aircall] Outgoing Call Answered';
  constructor(
    public payload: {
      call: AircallEverywhereOutgoingAnsweredEvent;
    }
  ) {}
}

export class AircallCallEnded {
  static readonly type = '[Aircall] Call Ended';
  constructor(
    public payload: {
      call: AircallEverywhereCallEndedEvent;
    }
  ) {}
}

export class AircallUserLoggedIn {
  static readonly type = '[Aircall] User Logged In';
  constructor(public payload: any) {}
}

export class AircallUserLoggedOut {
  static readonly type = '[Aircall] User Logged Out';
}

export class AircallTogglePanel {
  static readonly type = '[Aircall] Toggle Panel';
}

export class AircallOutgoingCallStarted {
  static readonly type = '[Aircall] Outgoing Call Started';
  constructor(
    public payload: {
      call: AircallEverywhereOutgoingCallEvent;
    }
  ) {}
}

export class SetVoiceCallContext {
  static readonly type = '[Aircall] Set Voice Call Context';
  constructor(public payload: { contextData: VoiceCallContext; persist?: boolean }) {}
}

export class GetVoiceCallContextByCallProviderId {
  static readonly type = '[Aircall] Get Voice Call Context By Call Provider Id';
  constructor(public payload: { providerCallId: string }) {}
}

export class TriggerPreCallPrep {
  static readonly type = '[Aircall] Trigger Pre Call Prep';
  constructor(public payload: { phoneNumber: string }) {}
}

export class TriggerPostCallWrapUp {
  static readonly type = '[Aircall] Trigger Post Call Wrap Up';
}

export class FinalizePostCallWrapUp {
  static readonly type = '[Aircall] Finalize Post Call Wrap Up';
}

export class DialPhoneNumber {
  static readonly type = '[Aircall] Dial Phone Number';
  constructor(public payload: { phoneNumber: string }) {}
}

export class CancelDial {
  static readonly type = '[Aircall] Cancel Dial';
}

export class ClearCallState {
  static readonly type = '[Aircall] Clear Call State';
}

export class GetAllMembersOutreachHistory {
  static readonly type = '[Aircall] Get All Members Outreach History';
  constructor(public payload: { memberGlobalId: number; filter?: string }) {}
}
